import React, { useState, useEffect, memo } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    Container,
    InputBase,
    Divider,
    AccordionActions,
    Button,
    Box,
    CircularProgress,
    IconButton,
    DialogActions,
    DialogTitle,
    Grid,
    Dialog,
    DialogContent
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import API from "../../actions";
import { PDFViewer, BlobProvider, Document } from "@react-pdf/renderer";
import MyDocument from "./MyDocument.js";
import moment from "moment";
import SendInvoice from "./SendInvoice.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import FirstPage from "./FirstPage.js";
import { Close, Delete } from "@material-ui/icons";

export function getMinMaxDatesWithoutUpdate(dates) {
    let minFrom = new Date(Math.min(...dates.map(d => d.from)));
    let firstSecondOftheDayFrom = new Date(minFrom.getFullYear(), minFrom.getMonth(), minFrom.getDate());

    let maxTo = new Date(Math.max(...dates.map(d => d.to)));
    let lastSecondOfTheDayTo = new Date(maxTo.getFullYear(), maxTo.getMonth(), maxTo.getDate(), 23, 59, 59, 999);

    return {
        minFrom: firstSecondOftheDayFrom,
        maxTo: lastSecondOfTheDayTo
    };
}

export function formatDate(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary
    },
    searchBar: {
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(2, 2),
        color: "#fff"
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: fade(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto"
        }
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    inputRoot: {
        color: "inherit"
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch"
        }
    }
}));

const GetInvoiceImg = props => {
    const [img, setImg] = useState("");

    useEffect(() => {
        if (!props.open) return;
        (async () => {
            setImg(await API.getInvoice(props.id));
        })();
    }, [props.id, props.open]);
    if (!props.open) return null;
    if (!img.image) return <></>;

    const inv = JSON.parse(img.image);

    // const getInvoiceNumber = props => {
    //     let invoiceNumber =
    //         "" +
    //         (props.number !== undefined
    //             ? props.number
    //             : props.company
    //             ? props.company.invoiceCount
    //             : props.therapist.invoiceCount);

    //     if (invoiceNumber.length < 4) {
    //         invoiceNumber = "0" + invoiceNumber;
    //     }
    //     return invoiceNumber;
    // };

    if (Array.isArray(inv)) {
        return (
            <>
                <PDFViewer style={{ width: "100%", minHeight: "100vh    " }}>
                    <Document
                        title={
                            (props.invoice.isMerged ? "samlet opgørelse #" : "Faktura Nummer #") +
                            getInvoiceNumbertext(props.invoice)
                        }>
                        <FirstPage inv={inv} />
                        {inv
                            .sort((a, b) => a.booking.from - b.booking.from)
                            .map((i, index) => {
                                const a = i;
                                return (
                                    <MyDocument
                                        key={a.id}
                                        therapist={a.therapist}
                                        company={a.company}
                                        client={a.client}
                                        treatment={a.treatment}
                                        booking={a.booking}
                                        journal={a.journal}
                                        upComing={a.upComing}
                                        stamJournal={a.stamJournal}
                                        settings={a.settings}
                                        number={a.number}
                                    />
                                );
                            })}
                    </Document>
                </PDFViewer>
            </>
        );
    }

    return (
        <>
            <PDFViewer style={{ width: "100%", minHeight: "400px" }}>
                <Document
                    title={
                        (props.invoice.isMerged ? "samlet opgørelse #" : "Faktura Nummer #") +
                        getInvoiceNumbertext(props.invoice)
                    }>
                    <MyDocument
                        therapist={inv.therapist}
                        company={inv.company}
                        client={inv.client}
                        treatment={inv.treatment}
                        booking={inv.booking}
                        journal={inv.journal}
                        upComing={inv.upComing}
                        stamJournal={inv.stamJournal}
                        settings={inv.settings}
                        number={inv.number}
                    />
                </Document>
            </PDFViewer>
            <BlobProvider
                document={
                    <MyDocument
                        therapist={inv.therapist}
                        company={inv.company}
                        client={inv.client}
                        treatment={inv.treatment}
                        booking={inv.booking}
                        journal={inv.journal}
                        upComing={inv.upComing}
                        stamJournal={inv.stamJournal}
                        settings={inv.settings}
                        number={inv.number}
                    />
                }>
                {({ blob, url, loading, error }) => {
                    if (!blob) return <></>;
                    const a = new FileReader();
                    a.onload = e => props.setFile(e.target.result);
                    a.readAsDataURL(blob);
                    return <div> </div>;
                }}
            </BlobProvider>
        </>
    );
};

export const getInvoiceNumbertext = invoice => {
    console.log(
        invoice.number,
        "0" + invoice.number + new Date(invoice.createdAt).getFullYear().toString().substr(2, 2),
        Number(invoice.number) < 10,
        invoice
    );
    if (Number(invoice.number) < 10) {
        return "0" + invoice.number + new Date(invoice.createdAt).getFullYear().toString().substr(2, 2);
    }
    return invoice.number + new Date(invoice.createdAt).getFullYear().toString().substr(2, 2);
};

export default memo(props => {
    const classes = useStyles();
    const [search, setSearch] = useState("");
    const [expanded, setExpanded] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [file, setFile] = useState("");
    const location = useLocation();
    const data = location.state;

    const isForClient = !!props?.bookingIds || !!props?.clientId;
    const [loading, setLoading] = useState(false);
    const [key, setKey] = useState(0);

    const [deleteLoading, setDeleteLoading] = useState(false);

    const deleteInvoice = async invoiceId => {
        setDeleteLoading(true);
        await API.deleteInvoice(invoiceId);
        setInvoices(invoices.filter(i => i.id !== invoiceId));
        setDeleteLoading(false);
    };

    useEffect(() => {
        (async () => {
            setLoading(true);
            const getInvoicesFromTherapist = !isForClient ? await API.getInvoicesFromTherapist() : [];
            console.log({ getInvoicesFromTherapist });
            const invoicesFromBookingIds = props.bookingIds ? await API.getInvoicesByBookingIds(props.bookingIds) : [];
            const mergedInvoicesByClientId = props.clientId
                ? await API.getMergedInvoicesByClientId(props.clientId)
                : [];

            setInvoices([...invoicesFromBookingIds, ...mergedInvoicesByClientId, ...getInvoicesFromTherapist]);
            setLoading(false);
        })();
        if (data?.status === "success") {
        }
    }, [key]);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                    width: "100%"
                }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container style={{ overflowY: "auto", padding: !isForClient ? "10px" : "0px" }}>
            {!isForClient && (
                <div className={classes.searchBar}>
                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                            onChange={event => setSearch(event.target.value)}
                            placeholder="Navn eller CPR nr..."
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput
                            }}
                            inputProps={{ "aria-label": "search" }}
                        />
                    </div>
                </div>
            )}
            {invoices.map((invoice, i) => {
                function getMinMaxDates(dates) {
                    let minFrom = new Date(Math.min(...dates.map(d => d.from)));
                    let maxTo = new Date(Math.max(...dates.map(d => d.to)));

                    return {
                        minFrom: formatDate(minFrom),
                        maxTo: formatDate(maxTo)
                    };
                }

                if (
                    !invoice.CPR.includes(search) &&
                    !(invoice.nameFirst + " " + invoice.nameLast).toLowerCase().includes(search.toLowerCase())
                )
                    return <></>;
                return (
                    <Accordion
                        key={invoice.id}
                        expanded={expanded === "panel" + i}
                        onChange={(event, isExpanded) => setExpanded(isExpanded ? "panel" + i : false)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={"panel" + i + "bh-content"}
                            id={"panel" + i + "bh-header"}
                            style={{
                                "& > div": {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "2px solid black"
                                }
                            }}>
                            <Typography
                                className={classes.heading + " "}
                                style={{ color: invoice.isMerged ? "#000000de" : "#4d5ccc", fontWeight: 500 }}>
                                {invoice.isMerged ? "samlet opgørelse #" : "Faktura nummer #"}
                                {getInvoiceNumbertext(invoice)}
                                {invoice.isMerged && console.log()}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {invoice.isMerged
                                    ? getMinMaxDates(
                                          JSON.parse(invoice.image).map(a => ({
                                              from: a.booking.from,
                                              to: a.booking.to
                                          }))
                                      )?.minFrom +
                                      " Til " +
                                      getMinMaxDates(
                                          JSON.parse(invoice.image).map(a => ({
                                              from: a.booking.from,
                                              to: a.booking.to
                                          }))
                                      )?.maxTo
                                    : moment(invoice.createdAt).format("DD/MM/YYYY")}{" "}
                                - {invoice.nameFirst} {invoice.nameLast} - {invoice.CPR}
                            </Typography>
                            {invoice.isMerged && props.onEdit && (
                                <>
                                    <Button
                                        style={{
                                            margin: 0,
                                            marginLeft: "auto",
                                            height: " 1.2   rem",
                                            fontSize: "0.75rem"
                                        }}
                                        variant="contained"
                                        color="primary"
                                        onClick={e => {
                                            e.stopPropagation();
                                            console.log({ mainInvoice: invoice });
                                            const image = JSON.parse(invoice.image)
                                                .map(i => ({
                                                    ...invoice,
                                                    number: Number(i.number.slice(0, -2)),
                                                    image: JSON.stringify([i])
                                                }))
                                                .map(b => getInvoiceNumbertext(b));

                                            props.onEdit({
                                                ids: image,
                                                invoice,
                                                start: getMinMaxDatesWithoutUpdate(
                                                    JSON.parse(invoice.image).map(a => ({
                                                        from: a.booking.from,
                                                        to: a.booking.to
                                                    }))
                                                )?.minFrom,
                                                end: getMinMaxDatesWithoutUpdate(
                                                    JSON.parse(invoice.image).map(a => ({
                                                        from: a.booking.from,
                                                        to: a.booking.to
                                                    }))
                                                )?.maxTo
                                            });
                                        }}
                                        size="small">
                                        Rediger
                                    </Button>
                                    <IconButton
                                        style={{
                                            padding: 0,
                                            marginLeft: "10px"
                                        }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setOpenDeleteDialog(invoice.id);
                                        }}>
                                        <Delete />
                                    </IconButton>
                                </>
                            )}

                            <Dialog
                                key={invoice.id}
                                maxWidth="lg"
                                open={openDeleteDialog === invoice.id}
                                aria-labelledby="form-dialog-title"
                                PaperProps={{
                                    style: {
                                        width: "100%",
                                        borderRadius: "25px",
                                        padding: "20px",
                                        maxWidth: "700px",
                                        overflowY: "visible",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        margin: "10px"
                                    },
                                    className: "date-picker-popup"
                                }}
                                className="date-picker-popup">
                                <Grid onClick={() => setOpenDeleteDialog(false)}>
                                    <Close
                                        style={{
                                            color: "#00000059",
                                            position: "absolute",
                                            right: "20px",
                                            fontSize: "40px",
                                            cursor: "pointer"
                                        }}
                                        className="close-icon"
                                    />
                                </Grid>
                                <DialogTitle
                                    id="form-dialog-title"
                                    style={{
                                        color: "black",
                                        fontSize: "22px !important",
                                        padding: "0px",
                                        paddingBottom: "5px"
                                    }}>
                                    Slet samlet opgørelse
                                </DialogTitle>
                                <DialogContent
                                    style={{
                                        padding: 0,
                                        paddingTop: "20px",
                                        paddingBottom: "20px"
                                    }}>
                                    <Typography
                                        variant="subtitle2"
                                        style={{ color: "#00000080", fontSize: "14px !important", padding: "0px" }}>
                                        Er du sikker på, at du vil slette den samlet opgørelse?
                                    </Typography>
                                </DialogContent>
                                <DialogActions style={{ justifyContent: "flex-start", padding: "0px" }}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={e => {
                                            e.stopPropagation();
                                            deleteInvoice(invoice.id);
                                            setOpenDeleteDialog(false);
                                        }}>
                                        Slet samlet opgørelse{" "}
                                        {deleteLoading && (
                                            <CircularProgress
                                                color="secondary"
                                                size={"20px"}
                                                style={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GetInvoiceImg
                                open={expanded === "panel" + i}
                                id={invoice.id}
                                invoice={invoice}
                                setFile={setFile}
                                clientId={invoice?.clientId}
                            />
                        </AccordionDetails>
                        <Divider />
                        <AccordionActions>
                            <Button
                                size="small"
                                onClick={(event, isExpanded) => {
                                    setExpanded(isExpanded ? "panel" + i : false);
                                }}>
                                Luk
                            </Button>
                            <SendInvoice id={invoice.id} file={file} />
                        </AccordionActions>
                    </Accordion>
                );
            })}
            {invoices.length === 0 && (
                <Box style={{ height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {props.clientId ? (
                        <Typography>Ingen samlet opgørelse fundet</Typography>
                    ) : (
                        <Typography>Ingen faktura fundet</Typography>
                    )}
                </Box>
            )}
        </Container>
    );
});
